import React, { useEffect, useRef } from "react"

import { baseUrlImg } from "../../config/api"

const PrintTicketTopUp = ({ arr }) => {
  let receiptData = []
  let receiptLink = ""

  try {
    const parsed = JSON.parse(arr.receipt)

    if (Array.isArray(parsed)) {
      receiptData = parsed

      const receiptLine = receiptData.find(
        (line) => typeof line === "string" && line.startsWith("receiptLink:"),
      )

      receiptLink = receiptLine ? receiptLine.replace("receiptLink:", "").trim() : ""

      receiptData = receiptData.filter(
        (line) => typeof line !== "string" || !line.startsWith("receiptLink:"),
      )
    } else if (parsed && typeof parsed === "object") {
      const numericKeys = Object.keys(parsed)
        .filter((key) => /^\d+$/.test(key))
        .sort((a, b) => Number(a) - Number(b))

      if (numericKeys.length > 0) {
        receiptData = numericKeys.map((key) => parsed[key])

        receiptLink =
          typeof parsed.receiptLink === "string" ? parsed.receiptLink.trim() : ""
      } else {
        if (parsed.receiptLink) {
          receiptLink = parsed.receiptLink
        }

        const addLine = (label, value) => {
          if (value === null || value === undefined || value === "") {
            return
          }

          receiptData.push({
            label,
            value: String(value),
          })
        }

        addLine("Tipo", parsed.TYPE)

        addLine("Importo", parsed.AMOUNT != null ? `${parsed.AMOUNT / 100}€` : null)

        addLine("Data / Ora", parsed.LOCALDATETIME)
        addLine("Terminale", parsed.TERMINALID)
        addLine("TXID", parsed.TXID)
        addLine("EAN", parsed.CARD?.EAN)
      }
    }
  } catch (error) {
    console.error("Failed to parse receipt:", error)
  }

  const hasOpenedRef = useRef(false)

  useEffect(() => {
    if (receiptLink && !hasOpenedRef.current) {
      hasOpenedRef.current = true

      window.open(receiptLink, "_blank", "noopener,noreferrer")
    }
  }, [receiptLink])

  const isDateLine = (text) =>
    /\d{1,2}[./-]\d{1,2}[./-]\d{2,4}\s+\d{1,2}:\d{2}(:\d{2})?/.test(text)

  const isValidLabelValuePair = (value) => {
    if (!value) return false

    const trimmed = value.trim()

    if (
      /^https?:\/\//i.test(trimmed) ||
      trimmed.includes("://") ||
      trimmed.includes("voda.it") ||
      trimmed.startsWith("www.") ||
      trimmed.includes("www.")
    ) {
      return false
    }

    if (trimmed.length > 25) return false

    if (/\d/.test(trimmed)) return true

    return false
  }

  const renderReceiptLines = () => {
    const result = []

    for (let i = 0; i < receiptData.length; i++) {
      const item = receiptData[i]

      if (item && typeof item === "object") {
        result.push(
          <div
            key={i}
            style={{
              display: "flex",
              justifyContent: "space-between",
              fontSize: "14px",
              borderBottom: "1px dashed",
              paddingBottom: "2px",
              margin: "7px 0",
              gap: "10px",
            }}
          >
            <span>{item.label}</span>

            <span
              style={{
                textAlign: "right",
                wordBreak: "break-word",
              }}
            >
              {item.value}
            </span>
          </div>,
        )

        continue
      }

      const line = item?.trim()

      if (!line) {
        result.push(
          <div
            key={i}
            style={{
              height: "10px",
            }}
          />,
        )

        continue
      }

      if (/^[-\s]+$/.test(line)) {
        continue
      }

      if (isDateLine(line)) {
        result.push(
          <div
            key={i}
            style={{
              margin: "7px 0",
              fontSize: "14px",
            }}
          >
            {line}
          </div>,
        )

        continue
      }

      if (line.endsWith(":") && receiptData[i + 1]) {
        const nextItem = receiptData[i + 1]

        if (typeof nextItem === "string") {
          const value = nextItem.trim()

          if (isValidLabelValuePair(value)) {
            result.push(
              <div
                key={i}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontSize: "14px",
                  borderBottom: "1px dashed",
                  paddingBottom: "2px",
                  margin: "7px 0",
                  gap: "10px",
                }}
              >
                <span>{line}</span>

                <span
                  style={{
                    textAlign: "right",
                    wordBreak: "break-word",
                  }}
                >
                  {value}
                </span>
              </div>,
            )

            i++
            continue
          }
        }
      }

      const colonIndex = line.indexOf(":")

      if (colonIndex > 0) {
        const label = line.slice(0, colonIndex + 1).trim()
        const value = line.slice(colonIndex + 1).trim()

        if (isValidLabelValuePair(value)) {
          result.push(
            <div
              key={i}
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontSize: "14px",
                borderBottom: "1px dashed",
                paddingBottom: "2px",
                margin: "7px 0",
                gap: "10px",
              }}
            >
              <span>{label}</span>

              <span
                style={{
                  textAlign: "right",
                  wordBreak: "break-word",
                }}
              >
                {value}
              </span>
            </div>,
          )

          continue
        }
      }

      result.push(
        <div
          key={i}
          style={{
            margin: "7px 0",
            fontSize: "14px",
          }}
        >
          {line}
        </div>,
      )
    }

    return result
  }

  return (
    <div
      className="pin-receipt"
      style={{
        fontFamily: "monospace",
        fontSize: "14px",
        lineHeight: 1.6,
        backgroundColor: "#fff",
      }}
    >
      <div
        className="receipt-info"
        style={{
          textAlign: "center",
          marginBottom: "20px",
        }}
      >
        <img
          src={`${baseUrlImg}/${arr.logo}`}
          alt="service logo"
          style={{
            display: "inline-block",
            maxHeight: "60px",
            marginBottom: "10px",
          }}
        />
      </div>

      <div
        className="receipt-data"
        style={{
          width: "100%",
        }}
      >
        {renderReceiptLines()}
      </div>

      {receiptLink && (
        <div
          className="receipt-data"
          style={{
            width: "100%",
            marginTop: "10px",
            marginLeft: "5px",
          }}
        >
          <a
            href={receiptLink}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "#3b82f6",
              textDecoration: "underline",
              display: "inline-block",
            }}
          >
            CLICCA PER LA RICEVUTA
          </a>
        </div>
      )}
    </div>
  )
}

export default PrintTicketTopUp
